/* SearchFooter.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _23 = "._vwz41eps{line-height:var(--ds-space-100)}";
const _22 = "._zulp1eps{gap:var(--ds-space-100)}";
const _21 = "._2hwxutpp{margin-right:var(--ds-space-150,9pt)}";
const _20 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _19 = "._vwz41j6v{line-height:1rem}";
const _18 = "._k48p1nn1{font-weight:400}";
const _17 = "._zg8l4jg8{font-style:normal}";
const _16 = "._1wyboqnp{font-size:.75rem}";
const _15 = "._1bsb1crf{width:9pt}";
const _14 = "._2rko1y44{border-radius:4px}";
const _13 = "._bfhk146w{background-color:var(--ds-background-neutral)}";
const _12 = "._2lx21bp4{flex-direction:column}";
const _11 = "._1bah1h6o{justify-content:center}";
const _10 = "._1yt4y3tf{padding:var(--ds-space-0) var(--ds-space-050)}";
const _9 = "._4t3i7vkz{height:1pc}";
const _8 = "._1bsb1tcg{width:24px}";
const _7 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { media } from '@atlaskit/primitives/responsive';
import { Button } from '@atlassian/mpac-primitives';
import React from 'react';
import escapeSvg from './assets/escape.svg';
import returnSvg from './assets/return.svg';
import upDownSvg from './assets/up-down.svg';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _6 = "@media (min-width:64rem){._dm251txw{display:flex}}";
const _5 = "._1bah1yb4{justify-content:space-between}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1e0cglyw{display:none}";
const _2 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _ = "._1yt4g30r{padding:var(--ds-space-200) var(--ds-space-300)}";
const Footer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4g30r _zulpxjmg _1e0cglyw _4cvr1h6o _1bah1yb4 _dm251txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Footer.displayName = 'Footer';
}
const Icon = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "dt",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _11, _4, _2, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bsb1tcg _4t3i7vkz _1yt4y3tf _1bah1h6o _4cvr1h6o _zulpxjmg _2lx21bp4 _bfhk146w _2rko1y44", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Icon.displayName = 'Icon';
}
const IconImg = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1crf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconImg.displayName = 'IconImg';
}
const ActionText = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _17, _18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz41j6v _syaz1k3w _2hwxutpp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionText.displayName = 'ActionText';
}
const ActionInfoWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _22, _4, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _zulp1eps _4cvr1h6o _vwz41eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionInfoWrapper.displayName = 'ActionInfoWrapper';
}
const viewCloseButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: "var(--ds-space-050)",
  lineHeight: "var(--ds-space-200)"
};
function ActionInfo(_ref6) {
  let {
    icon,
    text,
    alt
  } = _ref6;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Icon, {
      children: /*#__PURE__*/_jsx(IconImg, {
        src: icon,
        alt: "".concat(alt, " icon")
      })
    }), /*#__PURE__*/_jsx(ActionText, {
      children: /*#__PURE__*/_jsx("span", {
        "aria-label": "".concat(text, " label"),
        children: text
      })
    })]
  });
}
export function SearchFooter(_ref7) {
  let {
    closeOverlay
  } = _ref7;
  return /*#__PURE__*/_jsxs(Footer, {
    children: [/*#__PURE__*/_jsxs(ActionInfoWrapper, {
      title: "Navigation info",
      children: [/*#__PURE__*/_jsx(ActionInfo, {
        icon: upDownSvg,
        text: "Navigate",
        alt: "Up and Down arrow key"
      }), /*#__PURE__*/_jsx(ActionInfo, {
        icon: returnSvg,
        text: "Select",
        alt: "Enter/Return"
      }), /*#__PURE__*/_jsx(ActionInfo, {
        icon: escapeSvg,
        text: "Close",
        alt: "Escape"
      })]
    }), /*#__PURE__*/_jsx(Button, {
      onClick: closeOverlay,
      "aria-label": "Close overlay",
      testId: "CloseButton",
      style: viewCloseButtonStyle,
      iconAfter: /*#__PURE__*/_jsx(EditorCloseIcon, {
        label: "CloseOverlay",
        size: "medium"
      }),
      appearance: "link",
      children: "Close"
    })]
  });
}